import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

export const CustomPercentRing = ({ percent }: { percent: number }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* Black ring (the "track") */}
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{
          color: '#000' // black ring
        }}
        size={90}
        thickness={2}
      />

      {/* Blue arc for the actual progress */}
      <CircularProgress
        variant="determinate"
        value={percent}
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          color: '#0072CE' // blue arc
        }}
        size={90}
        thickness={2}
      />

      {/* Centered label (e.g. "7%") */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Calibri',
            fontWeight: 700,
            fontSize: '45px',
            color: '#007ACC',
            margin: '0.625rem'
          }}
        >
          {percent}%
        </Typography>
      </Box>
    </Box>
  );
};
